export const Style = ({ colors = [] }) => (
  <g id="Estilo1_5_">
    <linearGradient
      id="SVGID_194_"
      gradientUnits="userSpaceOnUse"
      x1="91.3843"
      y1="-319.03"
      x2="99.6734"
      y2="-319.03"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ fill: 'url(#SVGID_194_)' }}
      d="M95.2,71.6c1.6-1.8,5.4-7.6,4.3-21.3l-3.6,3.5l1.1,4.8C96.5,64.5,95.8,68.6,95.2,71.6z"
    />

    <linearGradient
      id="SVGID_195_"
      gradientUnits="userSpaceOnUse"
      x1="51.8635"
      y1="-314.97"
      x2="59.448"
      y2="-314.97"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ fill: 'url(#SVGID_195_)' }}
      d="M55,57.2L52.6,59c-2.6,9.7,2.3,13.1,3.8,13.8c-0.8-4.4-1.6-9.8-1.6-11.8L55,57.2z"
    />
    <path
      style={{ fill: '#401F43' }}
      d="M60.1,60.4c-0.2-0.1,6.4-4.3,10.5-4.1c0.1,0.1-0.1-4.5-5.5-2.5C59.8,55.9,60.1,60.5,60.1,60.4z"
    />
    <path
      style={{ fill: '#401F43' }}
      d="M90.1,60.4c0.2-0.1-6.4-4.3-10.5-4.1c-0.1,0.1,0.4-4.6,5.8-2.7C90.6,55.8,90,60.5,90.1,60.4z"
    />

    <linearGradient
      id="SVGID_196_"
      gradientUnits="userSpaceOnUse"
      x1="44.65"
      y1="437.3794"
      x2="103.39"
      y2="437.3794"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ fill: 'url(#SVGID_196_)' }}
      d="M50.4,37.9C50.2,26,66.2,23.6,66.2,23.6c13-1.5,19.5,1,21.7,5.5c3.3-0.9,8.2-1,11.6,4.5 c5.5,8.9-3.2,16.1,3.9,23c0,0-5.9,6.5-12.3,1.7c-3.6-2.7-3.8-8.6-4.1-14.3c-1.3,4.8-4.8,10.8-15.2,10.9c-15.8,0.2-16,7-16,7 s-3.3-1.2-7-4.3C38.6,49.7,50.4,37.9,50.4,37.9z"
    />

    <linearGradient
      id="SVGID_197_"
      gradientUnits="userSpaceOnUse"
      x1="50.4285"
      y1="449.4525"
      x2="87.93"
      y2="449.4525"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: '#FFDEC7' }} />
      <stop offset="0.9944" style={{ stopColor: '#7C297F' }} />
    </linearGradient>
    <path
      style={{
        opacity: '0.3',
        fill: 'url(#SVGID_197_)',
        enableBackground: 'new',
        mixBlendMode: 'multiply'
      }}
      d="M87.9,29.2c-2.2-4.6-8.7-7.1-21.7-5.5 c0,0-16,2.4-15.8,14.3c0,0,3.2-8.7,12.6-11.1C72.5,24.4,79.7,24.4,87.9,29.2z"
    />

    <linearGradient
      id="SVGID_198_"
      gradientUnits="userSpaceOnUse"
      x1="87.93"
      y1="444.356"
      x2="101.4692"
      y2="444.356"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: '#FFDEC7' }} />
      <stop offset="0.9944" style={{ stopColor: '#7C297F' }} />
    </linearGradient>
    <path
      style={{
        opacity: '0.3',
        fill: 'url(#SVGID_198_)',
        enableBackground: 'new',
        mixBlendMode: 'multiply'
      }}
      d="M101.3,42.6c0.3-2.8,0.2-5.8-1.8-9 c-3.4-5.5-8.3-5.4-11.6-4.5C87.9,29.2,98.5,29.4,101.3,42.6z"
    />
  </g>
)

export const Back = ({ colors = [] }) => (
  <g id="Estilo1_11_">
    <linearGradient
      id="SVGID_6_"
      gradientUnits="userSpaceOnUse"
      x1="49.7127"
      y1="409.3632"
      x2="100.4858"
      y2="409.3632"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_6_)' }}
      d="M52.6,50.1c0,0-6.8,27.5,0.4,38.7l1.5-4.4c0,0-1.2,11.1,22.6,11.2 c17,0,18.6-9.9,18.6-9.9l0,5.2c0,0,7.1-8.9,3.9-37.6C98.4,41.7,54.1,45.6,52.6,50.1z"
    />
  </g>
)

Style.Back = Back
